<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/SharedUI/Footer.vue';
</script>

<template>
  <Navbar/>
  <v-container class="py-8 mx-auto" max-width="1200" style="margin-top: 60px;">
    <v-card elevation="3">
      <v-card-title class="text-h5 font-weight-bold">
        Terms and Conditions
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Introduction</h3>
          <p>
            Welcome to MeroPrints – your complete solution for school ID card design, printing, and RFID integration. Our platform helps schools and institutions streamline the process of creating professional ID cards for students, teachers, staff, and visitors. Please read the following Terms and Conditions before using our services.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Acceptance of Terms</h3>
          <p>
            By accessing or using the MeroPrints website or services, you agree to be bound by these Terms and Conditions. If you do not agree to any part of the terms, please do not use our services.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Services Provided</h3>
          <p>
            MeroPrints offers services such as designing, printing, and delivering ID cards, including RFID and barcode-enabled cards. We also provide online tools to customize templates, upload photos and data, and manage school identity systems.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">User Responsibilities</h3>
          <p>
            Users are responsible for providing accurate and lawful content, including names, photos, logos, and institution details. You must ensure that you have permission to use all uploaded content.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Data Privacy</h3>
          <p>
            We respect your privacy and handle all submitted personal data, including student and staff information, with strict confidentiality. Please refer to our <a href="/privacy-policy">Privacy Policy</a> for detailed information.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Intellectual Property</h3>
          <p>
            All design templates, tools, and materials on the MeroPrints platform are the intellectual property of our company or its licensors. Users may not reuse, sell, or distribute these without permission.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Payment and Orders</h3>
          <p>
            All orders must be paid in full before processing begins. MeroPrints reserves the right to cancel or reject orders if content is found to violate our guidelines or applicable laws.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Warranties and Disclaimers</h3>
          <p>
            Our services are provided "as is" and "as available". While we strive for quality and accuracy, we do not guarantee that our platform will be error-free or uninterrupted.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Limitation of Liability</h3>
          <p>
            MeroPrints is not liable for indirect or consequential damages arising from the use of our services. In any case, our maximum liability will not exceed the amount paid for the disputed service.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Modifications to Terms</h3>
          <p>
            We may update these Terms and Conditions at any time. Continued use of the platform after updates constitutes acceptance of the revised terms.
          </p>
        </section>

        <section class="mb-6">
          <h3 class="text-h6 font-weight-medium">Governing Law</h3>
          <p>
            These Terms shall be governed by and interpreted in accordance with the laws of Nepal. Any disputes shall be resolved under the jurisdiction of the Nepalese courts.
          </p>
        </section>

        <section>
          <h3 class="text-h6 font-weight-medium">Contact Us</h3>
          <p>
            For questions or concerns about these Terms and Conditions, please contact us at <a href="mailto:contact@brosoftltd.com">contact@brosoftltd.com</a>.
          </p>
        </section>
      </v-card-text>
    </v-card>
  </v-container>
  <Footer/>
</template>

<style scoped>
p {
  line-height: 1.8;
  font-size: 16px;
  color: #424242;
  margin-bottom: 1rem;
}
h3 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
a {
  color: #1976d2;
  text-decoration: underline;
}
a:hover {
  color: #1565c0;
  text-decoration: none;
}
</style>
